__turbopack_context__.v({
  "container": "Container-module-scss-module__iwLWga__container",
});
